<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                element="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.tags', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="divide-y divide-gray-200">
            <div class="mt-5" v-for="tagCategory in tagCategories" :key="tagCategory.id">
                <TitleFieldsFormSection class="mt-5">
                    <template v-slot:title>
                        {{ tagCategory.display_name }}
                    </template>

                    <div class="flex gap-2 flex-wrap">
                        <BadgePill
                            :color="tag.student_files_count > 0 ? 'indigo' : 'gray'"
                            v-for="tag in tagCategory.tags"
                            :key="tag.id"
                        >
                            <InertiaLink :href="tag.links.edit">
                                {{ tag.display_name }}: {{ tag.student_files_count }}
                            </InertiaLink>
                        </BadgePill>
                    </div>
                </TitleFieldsFormSection>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import BadgePill from '@/components/BadgePill.vue';

export default {
    components: {
        BadgePill,
        TitleFieldsFormSection,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'tagCategories'],
};
</script>
